import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';

// Utils
import events from '../../../../lib/events.js';
import router from '../../../../lib/router.js';
import routeUtils from '../../../../util/routeUtils.jsx';
import session from '../../../../services/sessionService.jsx';
import {intlShape, injectIntl} from 'react-intl';
// Components
import Header from '../../../components/layout/header.jsx';
import Loader from '../../../components/loader.jsx';
import IntlWrapper from 'components/layout/intlWrapper';
import ProblemFollowUps from './problemFollowUps.jsx';
import CompletedFollowUps from './completedFollowUps.jsx';
import MissingCustomerReport from './missingCustomers.jsx';
import PastDueCustomersReport from './pastDueCustomers';

// Api
import BranchApi from '../../../../api/branch.jsx';
import DealerApi from '../../../../api/dealer.jsx';
import waterTesterApi from '../../../../api/waterTester.jsx';
import {connectToPerformanceFile, PERFORMANCE_KEYS} from 'ui/helpers/performanceFile';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';

// Register in router
const render = (container, params) => {
  console.info('[UI.page.reports.followups] rendering page');
  ReactDOM.render(<IntlWrapper><FollowUpsReport subPageName={params.subPage}/></IntlWrapper>, container);
  events.publish('page-change', {page: 'reports'});
};

console.info('[UI.page.reports.followups] register route');
router.rr.add([{path: 'reports/followups/:subPage', handler: routeUtils.requireAdmin(render)}]);

class _FollowUpsReport extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      user: session.getUser(),
      loaded: false,
    };
  }

  componentWillMount() {
    const apis = [];

    apis.push(BranchApi.getMyBranches());
    apis.push(DealerApi.getDealer(this.state.user.dealerId));
    apis.push(waterTesterApi.getWaterTesters());
    Promise.all(apis)
      .then(([branches, dealer, testers]) => {
        console.log('branches', branches);
        console.log('dealer', dealer);
        this.setState({
          loaded: true,
          dealer: dealer,
          branches: branches,
          testers: testers,
        });
      }).catch(err => {
        console.log('error', err);
      });
  }

  checkPOSPermission() {
    const {user, dealer} = this.state;

    if (user && dealer && dealer.CurrentPOSIntegration === 0) {
      return false;
    } else if (user.isDealerAdmin) {
      return true;
    } else if (user.isAdmin && dealer.managerDetailedReporting) {
      return true;
    } else if (user.isTestStation && dealer.testerDetailedReporting) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    const {subPageName} = this.props;
    const {branches, testers} = this.state;
    let {formatMessage} = this.props.intl;
    const subPages = {
      'missing-customers': {
        name: formatMessage({id: 'reports.followups.missing.customers'}),
        element: <MissingCustomerReport branches={branches}/>,
      },
      'open-follow-ups': {
        name: formatMessage({id: 'reports.followups.open.followups'}),
        element: <ProblemFollowUps branches={branches}
                                   testers={testers}/>,
      },
      'completed-follow-ups': {
        name: formatMessage({id: 'reports.followups.completed.followups'}),
        element: <CompletedFollowUps branches={branches}
                                     testers={testers}/>,
      },
      'past-due': {
        name: formatMessage({id: 'reports.followups.pastdue.followup'}),
        element: <PastDueCustomersReport branches={branches}/>,
      },
    };
    const subPagesTabs = Object.keys(subPages)
      .map(sp => <a key={sp}
                    className={subPageName === sp ? subPages[sp].className + ' active' : subPages[sp].className}
                    href={'#reports/followups/' + sp}>{subPages[sp].name}
      </a>);
    const subPage = subPages[subPageName].element;

    return (
      <div className='container'>
        <div id='page-reports'>
          <div className='nav-tabs'>
            <Header mainTitle={formatMessage({id: 'reports.title'})}
                    subTitle={formatMessage({id: 'reports.followups'})}
                    mainTitleReturn='reports'/>
          </div>
          <nav className='navigation-tabs'>
            {subPagesTabs}
          </nav>
          <Loader loaded={this.state.loaded}>
            <div className='report-details'>
              {subPage}
            </div>
          </Loader>
        </div>
      </div>
    );
  }
}

_FollowUpsReport.propTypes = {
  subPageName: PropTypes.string.isRequired,
};

const FollowUpsReport = injectIntl(bindLocaleUpdate(connectToPerformanceFile(PERFORMANCE_KEYS.reports)(_FollowUpsReport)));

export default FollowUpsReport;
